import { PaletteController } from '../../../base/ts/PaletteController';

function boot(): void {
	const config = window.cmfeFrontend?.activeMode;
	console.log( '[cmfe] boot', { activeMode: config } );

	if ( config && document.body ) {
		console.log( '[cmfe] attaching body mode', config );
		window.cmfe = PaletteController.createFromConfig( config, document.body );
	} else {
		console.log( '[cmfe] no activeMode — body skipped' );
	}

	const elements = document.querySelectorAll<HTMLElement>( '[data-cmfe-type]' );
	console.log( '[cmfe] found', elements.length, 'element(s) with data-cmfe-type' );

	elements.forEach( ( el ) => {
		const elConfig = PaletteController.readConfigFromElement( el );
		console.log( '[cmfe] element config', elConfig, el );
		if ( elConfig ) {
			PaletteController.createFromConfig( elConfig, el );
		}
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', boot );
} else {
	boot();
}
